let Components = {};

Components['DialogFormSales'] = require('../../app/routes/MasterSales/DialogForm').default;
Components['DialogFormVehicleLicense'] = require('../../app/routes/MasterVehicleLicense/DialogForm').default;
Components['DialogFormDriverLicense'] = require('../../app/routes/MasterDriverLicense/DialogForm').default;
Components['DialogFormArea'] = require('../../app/routes/MasterArea/DialogForm').default;
Components['DialogFormBusinessType'] = require('../../app/routes/MasterBusinessType/DialogForm').default;
Components['DialogFormCountry'] = require('../../app/routes/MasterCountry/DialogForm').default;
Components['DialogFormCustomer'] = require('../../app/routes/MasterCustomer/DialogForm').default;
Components['DialogFormMeasurement'] = require('../../app/routes/MasterMeasurement/DialogForm').default;
Components['DialogFormVehicleType'] = require('../../app/routes/MasterVehicleType/DialogForm').default;
Components['DialogFormVendor'] = require('../../app/routes/MasterVendor/DialogForm').default;
Components['DialogFormDriver'] = require('../../app/routes/MasterDriver/DialogAdd').default;
Components['DialogFormVehicle'] = require('../../app/routes/MasterVehicle/DialogAdd').default;
// Components['Component2'] = require('./Component2').default;
// Components['Component3'] = require('./Component3').default;

export default Components


// WEBPACK FOOTER //
// ./components/InputVirtual/ComponentIndex.js